import { useAtom } from 'jotai';
import { Button, Indicator } from '@optiaxiom/react';
import { IconBell } from '@optimizely/axiom-icons';

import { activeRightSidebarAtom } from '@frontend/atoms';
import { useUnreadCount } from '@frontend/features/notifications/hooks';
import { formatUnreadCount } from '@frontend/features/notifications/utils';

export function NotificationBellButton() {
  const [activeRightSidebar, setActiveRightSidebar] = useAtom(activeRightSidebarAtom);
  const { data: unreadCount } = useUnreadCount();
  const badgeContent = formatUnreadCount(unreadCount);

  return (
    <Button
      appearance="subtle"
      aria-label="Notifications"
      icon={
        <Indicator content={badgeContent} disabled={!badgeContent} intent="danger" variant="strong">
          <IconBell />
        </Indicator>
      }
      onClick={() =>
        setActiveRightSidebar(activeRightSidebar === 'notifications' ? null : 'notifications')
      }
      size="lg"
      square
    />
  );
}
